import { defineStore } from 'pinia';
import { tenantApi } from '@api';

export const useTenantStore = defineStore('tenant', {
    state: () => {
        return {
            loading: false,
            tenantId: null,
            tenantData: {},
            data: {},
            collection: [],
        };
    },

    getters: {
        haveStripeAccount: (state) => !!state.tenantData?.company?.settings?.stripe_id,
        getTenantSlug: (state) => state.tenantData?.company?.slug,
        isStripeVerified: (state) => !!state.tenantData?.company?.settings?.stripe_verified,
        allowSupport: (state) => state.tenantData?.allow_support,
        getTenantId: (state) => state.tenantData?.id,
    },

    actions: {
        async index() {
            try {
                const tenants = await tenantApi.index();

                this.collection = tenants;
            } catch (error) {
                this.loading = false;

                throw error;
            }
        },

        async create(data) {
            try {
                this.loading = true;

                const tenant = await tenantApi.create(data);

                this.loading = false;

                return tenant;
            } catch (error) {
                this.loading = false;

                throw error;
            }
        },

        async retrieve(tenantId) {
            try {
                this.loading = true;

                const tenant = await tenantApi.retrieve(tenantId);
                this.tenantData = tenant;
                this.loading = false;
                this.tenantData = tenant;

                return tenant;
            } catch (error) {
                this.loading = false;

                // let the form component display the error
                throw error;
            }
        },

        async update(tenantId, data) {
            try {
                this.loading = true;

                const tenant = await tenantApi.update(tenantId, data);
                this.tenantData = tenant;
                this.loading = false;

                return tenant;
            } catch (error) {
                this.loading = false;

                throw error;
            }
        },
    },
});
